import { Block } from "./scenes/board-scene/Block";
import * as Templok from "@ravalmatic/templok-engine";

export class GameVars {

    public static gameData: GameDataTemplok;
    public static reactClass: any;
    public static scaleY: number;
    public static isDesktop: boolean;
    public static development: boolean;
    public static currentScene: Phaser.Scene;
    public static intitialised: boolean;
    public static paused: boolean;
    public static templokEngine: Templok.Engine;
    public static selectedBlock: Block;
    public static score: number;
    public static reRolling: boolean;
    public static seed: number;
    public static replayLog: Templok.Log;
    public static gameText: any;
    public static playerData: any;
    public static doingCombo: boolean;
    public static resumedGame: boolean;
    public static numOfCellDestroyed: number;
    public static gameOver: boolean;
    public static rewardedAdAvailable: boolean;

    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public static getTimeUntilEndOfDay(): number {

        const d = new Date();
        const h = d.getUTCHours();
        const m = d.getUTCMinutes();
        const s = d.getUTCSeconds();

        return (24 * 60 * 60) - (h * 60 * 60) - (m * 60) - s;
    }
}
